import React from 'react'

export default function SpaceBetween() {
  return (
    <div style={{display:'block',height:'88px'}}>
      
    </div>
  )
}
